import { render, staticRenderFns } from "./AudioguidePoint.vue?vue&type=template&id=60dc100e&"
import script from "./AudioguidePoint.vue?vue&type=script&lang=js&"
export * from "./AudioguidePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60dc100e')) {
      api.createRecord('60dc100e', component.options)
    } else {
      api.reload('60dc100e', component.options)
    }
    module.hot.accept("./AudioguidePoint.vue?vue&type=template&id=60dc100e&", function () {
      api.rerender('60dc100e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/points/AudioguidePoint.vue"
export default component.exports